"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MojosAuctionHouse__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "mojoId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "bool",
                name: "extended",
                type: "bool",
            },
        ],
        name: "AuctionBid",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "mojoId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "startTime",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "endTime",
                type: "uint256",
            },
        ],
        name: "AuctionCreated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "mojoId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "endTime",
                type: "uint256",
            },
        ],
        name: "AuctionExtended",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "minBidIncrementPercentage",
                type: "uint256",
            },
        ],
        name: "AuctionMinBidIncrementPercentageUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "reservePrice",
                type: "uint256",
            },
        ],
        name: "AuctionReservePriceUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "mojoId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address",
                name: "winner",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "AuctionSettled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "timeBuffer",
                type: "uint256",
            },
        ],
        name: "AuctionTimeBufferUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "Paused",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "Unpaused",
        type: "event",
    },
    {
        inputs: [],
        name: "auction1",
        outputs: [
            {
                internalType: "uint256",
                name: "mojoId",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "startTime",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "endTime",
                type: "uint256",
            },
            {
                internalType: "address payable",
                name: "bidder",
                type: "address",
            },
            {
                internalType: "bool",
                name: "settled",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "mojoId",
                type: "uint256",
            },
        ],
        name: "createBid",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [],
        name: "creationDate",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "duration",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract IMojosToken",
                name: "_mojos1",
                type: "address",
            },
            {
                internalType: "address",
                name: "_weth",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_timeBuffer",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_reservePrice",
                type: "uint256",
            },
            {
                internalType: "uint8",
                name: "_minBidIncrementPercentage",
                type: "uint8",
            },
            {
                internalType: "uint256",
                name: "_duration",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "_multisigFeeWallet",
                type: "address",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "minBidIncrementPercentage",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "mojos1",
        outputs: [
            {
                internalType: "contract IMojosToken",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "multiSigFeeWallet",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "oneYearHavePassed",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pause",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "paused",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "reservePrice",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint8",
                name: "_minBidIncrementPercentage",
                type: "uint8",
            },
        ],
        name: "setMinBidIncrementPercentage",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_reservePrice",
                type: "uint256",
            },
        ],
        name: "setReservePrice",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_timeBuffer",
                type: "uint256",
            },
        ],
        name: "setTimeBuffer",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "settleAuction",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "settleCurrentAndCreateNewAuction",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "timeBuffer",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "unpause",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "weth",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class MojosAuctionHouse__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.MojosAuctionHouse__factory = MojosAuctionHouse__factory;
MojosAuctionHouse__factory.bytecode = _bytecode;
MojosAuctionHouse__factory.abi = _abi;
